<template>
  <div class="content-v2">
    <div class="internal-layout-v2">
      <aside class="year-sidebar-v2">
        <div class="sidebar-title">{{ $t('common.journal') }}</div>
        <div class="year-list-v2">
          <button
            v-for="year in yearList"
            :key="year"
            :class="{ active: currentYear === year }"
            @click="currentYear = year"
          >
            {{ formatYearLabel(year) }}
          </button>
        </div>
      </aside>
      <div class="file-main-v2">
        <div class="file-card" v-for="item in filteredFiles" :key="item.id">
          <div class="file-icon-v2">
            <span>PDF</span>
          </div>
          <div class="file-info-v2">
            <h4>{{ item.title }}</h4>
            <p>{{ displayDesc(item.desc) }}</p>
          </div>
          <router-link :to="item.url" class="btn-download-v2">{{ $t('common.viewDetail') }}</router-link>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getNewsList } from '@/api/portal'
import { formatYear } from '@/utils/format'

export default {
  name: 'NewsInternalV2',
  data() {
    return {
      currentYear: 2026,
      yearList: [2026, 2025, 2024, 2023, 2022, 2021, 2020, 2019, 2018, 2017, 2016],
      fileList: [
        { id: 1, year: 2026, title: '2026年4月第246期', desc: '发布时间: 2026-04-20', url: { path: '/news/detail/1', query: { type: 'journal' } } },
        { id: 2, year: 2026, title: '2026年3月第245期', desc: '发布时间: 2026-03-15', url: { path: '/news/detail/2', query: { type: 'journal' } } },
        { id: 3, year: 2026, title: '2026年2月第244期', desc: '发布时间: 2026-02-10', url: { path: '/news/detail/3', query: { type: 'journal' } } },
        { id: 4, year: 2025, title: '2025年12月第242期', desc: '发布时间: 2025-12-20', url: { path: '/news/detail/4', query: { type: 'journal' } } },
        { id: 5, year: 2025, title: '2025年9月第239期', desc: '发布时间: 2025-09-05', url: { path: '/news/detail/5', query: { type: 'journal' } } },
        { id: 6, year: 2024, title: '2024年12月第238期', desc: '发布时间: 2024-12-18', url: { path: '/news/detail/6', query: { type: 'journal' } } },
        { id: 7, year: 2023, title: '2023年12月第235期', desc: '发布时间: 2023-12-20', url: { path: '/news/detail/7', query: { type: 'journal' } } },
        { id: 8, year: 2022, title: '2022年12月第233期', desc: '发布时间: 2022-12-10', url: { path: '/news/detail/8', query: { type: 'journal' } } }
      ]
    }
  },
  created() {
    this.loadFiles()
  },
  computed: {
    filteredFiles() {
      return this.fileList.filter(item => item.year === this.currentYear)
    }
  },
  methods: {
    formatYearLabel(year) {
      return this.$langState.locale === 'en' ? year : `${year}年`
    },
    displayDesc(desc) {
      return this.$langState.locale === 'en' ? desc.replace('发布时间', this.$t('common.publishedAt')) : desc
    },
    loadFiles() {
      getNewsList({ newsType: 'journal', pageNum: 1, pageSize: 100 }).then(({ rows }) => {
        if (!rows || !rows.length) {
          return
        }
        this.fileList = rows.map(item => {
          const year = Number(formatYear(item.publishTime)) || this.currentYear
          return {
            id: item.newsId,
            year,
            title: item.newsTitle,
            desc: `发布时间: ${item.publishTime || ''}`,
            url: { path: `/news/detail/${item.newsId}`, query: { type: 'journal' } }
          }
        })
        this.yearList = Array.from(new Set(this.fileList.map(item => item.year))).sort((a, b) => b - a)
        this.currentYear = this.yearList[0] || this.currentYear
      }).catch(() => {})
    }
  }
}
</script>

<style lang="scss" scoped>
.internal-layout-v2 {
  display: flex;
  gap: 40px;
}

.year-sidebar-v2 {
  width: 220px;
  flex-shrink: 0;

  .sidebar-title {
    background: linear-gradient(135deg, #3b82f6, #06b6d4);
    color: #fff;
    padding: 18px 24px;
    font-size: 18px;
    font-weight: 700;
    border-radius: 16px 16px 0 0;
  }

  .year-list-v2 {
    background: #fff;
    border: 1px solid #e2e8f0;
    border-top: none;
    border-radius: 0 0 16px 16px;
    overflow: hidden;

    button {
      display: block;
      width: 100%;
      padding: 14px 24px;
      text-align: left;
      border: none;
      border-bottom: 1px solid #e2e8f0;
      background: #fff;
      font-size: 15px;
      color: #475569;
      cursor: pointer;
      transition: all 0.3s;

      &:hover,
      &.active {
        background: linear-gradient(135deg, #3b82f6, #06b6d4);
        color: #fff;
      }

      &:last-child {
        border-bottom: none;
      }
    }
  }
}

.file-main-v2 {
  flex: 1;
}

.file-card {
  display: flex;
  align-items: center;
  padding: 24px;
  background: #fff;
  border: 1px solid #e2e8f0;
  border-radius: 16px;
  margin-bottom: 16px;
  transition: all 0.3s;

  &:hover {
    box-shadow: 0 8px 30px rgba(0,0,0,0.06);
  }

  .file-icon-v2 {
    width: 56px;
    height: 68px;
    background: linear-gradient(135deg, #ef4444, #f97316);
    border-radius: 10px;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
    margin-right: 24px;

    span {
      color: #fff;
      font-size: 12px;
      font-weight: 700;
    }
  }

  .file-info-v2 {
    flex: 1;

    h4 {
      font-size: 17px;
      font-weight: 600;
      color: #0f172a;
      margin-bottom: 6px;
    }

    p {
      font-size: 14px;
      color: #94a3b8;
    }
  }

  .btn-download-v2 {
    padding: 10px 28px;
    background: linear-gradient(135deg, #3b82f6, #06b6d4);
    color: #fff;
    font-size: 14px;
    font-weight: 600;
    border-radius: 10px;
    transition: all 0.3s;

    &:hover {
      box-shadow: 0 4px 15px rgba(59,130,246,0.4);
    }
  }
}

@media (max-width: 960px) {
  .internal-layout-v2 {
    flex-direction: column;
  }
  .year-sidebar-v2 {
    width: 100%;
  }
  .year-list-v2 {
    display: flex;
    flex-wrap: wrap;
    button { width: auto; flex: 1; min-width: 100px; text-align: center; }
  }
}
</style>
